import React from 'react';
import {ToastContainer} from "react-toastify";

import './App.css';
import 'react-toastify/dist/ReactToastify.min.css';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'

import ScrollToTop from './Helpers/ScrollToTop';
import Footer from './Containers/Footer';
import RecipientPage from './Pages/RecipientPage';
import BudgetPage from './Pages/BudgetPage';
import ThemePickerPage from "./Pages/ThemePickerPage";
import PersonalizePage from "./Pages/PersonalizePage";
import VerifyPage from './Pages/VerifyPage';
import PaymentPage from "./Pages/PaymentPage";
import WalletPage from './Pages/WalletPage';
import RequestPage from './Pages/RequestPage';
import FulfillPage from './Pages/FulfillPage';

import FAQPage from './Pages/FAQPage';
import StoryPage from './Pages/AboutPage';

import TermsAndConditions from './Pages/TermsAndConditions';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import PressPage from './Pages/PressPage';

import PageNotFoundPage from './Pages/PageNotFoundPage';

import PageContainer from "./Containers/PageContainer";

import { redirectToBlockchainDotCom } from "./Helpers/Redirect";

const App = () => (
  <Router>
    <ScrollToTop>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover />

      <PageContainer>
        <Switch>
          <Route exact path="/" component={RecipientPage}/>
          <Route path="/recipient" component={RecipientPage}/>
          <Route path="/budget" component={BudgetPage}/>
          <Route path="/theme" component={ThemePickerPage}/>
          <Route path="/personalize" component={PersonalizePage}/>
          <Route path="/verify" component={VerifyPage}/>
          <Route path="/payment" component={PaymentPage}/>
          <Route path="/request" component={RequestPage}/>
          <Route path="/giftbasket/:requesterEmail" component={FulfillPage}/>

          <Route path="/faq" component={FAQPage}/>
          <Route path="/about" component={StoryPage}/>

          <Route path="/terms" component={TermsAndConditions}/>
          <Route path="/privacy" component={PrivacyPolicy}/>
          <Route path="/press" component={PressPage}/>

          <Route path='/wallet/blockchain/:walletId?' component={WalletPage}/>
          <Route path='/redirect/wallet/blockchain/:walletId?' component={(route) => redirectToBlockchainDotCom(route.match.params.walletId || '')}/>

          <Route component={PageNotFoundPage} />
        </Switch>
      </PageContainer>
      <Footer/>
    </ScrollToTop>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js